import { AxiosResponse } from 'axios';

export function blobUrlFromBlobResponse(response: AxiosResponse) {
  const blob = new Blob([response.data], { type: 'application/pdf' });
  return URL.createObjectURL(blob);
}

export function blobUrlFromBlob(blob: Blob) {
  return URL.createObjectURL(blob);
}

export function downloadPdfFromBlobResponse(response: AxiosResponse) {
  const blob = new Blob([response.data], { type: 'application/pdf' });
  const blobUrl = URL.createObjectURL(blob);
  const disposition = response.headers['content-disposition'] || '';
  const filenameMatch = disposition.match(/filename="?([^";]+)"?/i);
  const filename = filenameMatch?.[1] ?? 'document.pdf';
  downloadPdfFromBlobUrl(blobUrl, filename);
}

export function downloadBlobFromResponse(response: AxiosResponse) {
  const contentType = response.headers['content-type'] || 'application/octet-stream';
  const blob = new Blob([response.data], { type: contentType });
  const blobUrl = URL.createObjectURL(blob);
  const disposition = response.headers['content-disposition'] || '';
  const filenameMatch = disposition.match(/filename="?([^";]+)"?/i);
  const filename = filenameMatch?.[1] ?? 'document';
  downloadPdfFromBlobUrl(blobUrl, filename);
}

export function downloadPdfFromBlobUrl(blobUrl: string, filename: string) {
  const link = document.createElement('a');
  link.href = blobUrl;
  link.setAttribute('download', filename);
  link.setAttribute('target', '_blank');
  document.body.appendChild(link);
  link.click();
}

export function b64toBlob({
  b64Data,
  contentType = '',
  sliceSize = 512
}: {
  b64Data: string;
  contentType?: string;
  sliceSize?: number;
}) {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: contentType });
  return blob;
}
